module.exports = __webpack_public_path__ + "static/media/get-started-email.a22da01e.svg";